import { useHistory, useRouteMatch } from 'react-router';
import { NavLink } from 'react-router-dom';

export const CohortSelector = () => {
  const history = useHistory();

  const cohorts = [
    {
      name: 'revenue_growth',
      label: 'Revenue growth',
      description:
        'How much do the customers spent after their first order repeat: when do the customers repurchase',
    },
    {
      name: 'repeat_purchase',
      label: 'Repeat purchase',
      description: 'Analyze what % of customers become repeats each month',
    },
    {
      name: 'churn_rate',
      label: 'Churn rate',
      description:
        'Understand when do customers stop purchase and becomes inactive',
    },
  ];
  // const currentPathname = history.location.pathname.split('/').pop();

  // const cohortDescription = cohorts.find(
  //   (cohort) => cohort.name === currentPathname
  // );

  let { url } = useRouteMatch();

  return (
    <div className=" mt-10 ">
      <div className="flex items-center space-x-4 px-6 py-4 mt-10 border divide-x rounded-2xl bg-segments-gray-F8">
        {cohorts.map((cohort) => (
          <NavLink
            key={cohort.name}
            className="px-6 py-3 inline-block rounded-full bg-segments-gray text-segments-13px capitalize cursor-pointer"
            activeClassName="bg-segments-accent-color-1 text-white"
            to={{ ...history.location, pathname: `${url}/${cohort.name}` }}
          >
            {cohort.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};
